import { useIntl } from "react-intl";
import { useAgentStore } from "@/stores/agent-store";

// Topbar entry point for the Assistant (see @adr SPARK-0019-assistant-lives-on-the-right-edge@1). A "smike" mascot
// button that toggles the right-side drawer. Wears `smycles-ai-shadow` to
// inherit the AI signal that prompt controls use elsewhere (see
// UI_CONVENTIONS.md → "Where AI lives"). The drawer itself lives in
// <AssistantDrawer />; this component just drives the store.
//
// The mascot has two faces: normal eyes (resting) and sparked eyes (blink).
// Today only the resting face shows; a later iteration swaps to the spark
// face on a periodic blink. See public/assistant/smike{,-spark}.png.
export function AssistantLauncher() {
  const intl = useIntl();
  const open = useAgentStore((s) => s.open);
  const toggleOpen = useAgentStore((s) => s.toggleOpen);

  const label = intl.formatMessage({ id: "agent.title", defaultMessage: "Assistant" });

  return (
    <button
      id="agent-launcher"
      type="button"
      onClick={toggleOpen}
      aria-label={label}
      aria-pressed={open}
      title={label}
      className={`grid h-9 w-9 shrink-0 place-items-center rounded-full transition hover:bg-ink/[0.06] ${
        open ? "bg-ink/[0.06] ring-1 ring-ink/15" : "smycles-ai-shadow bg-page"
      }`}
    >
      {/*
        The mascot faces left when resting; when the drawer is open it flips to
        face the chat on the right (scaleX(-1)). prefers-reduced-motion users
        get the flip without the glide. */}
      <img
        src="/assistant/smike.svg"
        alt=""
        aria-hidden
        draggable={false}
        className={`h-6 w-6 select-none transition-transform duration-200 motion-reduce:transition-none ${
          open ? "-scale-x-100" : ""
        }`}
      />
    </button>
  );
}
